import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import Room from './pages/Room';
import JoinRoom from './pages/JoinRoom';
import usePageTracking from './hooks/usePageTracking';
import './i18n'; // i18n設定を初期化
import './App.css';

// ホーム/ルーム/参加はセッションの大半で訪れる経路なので即時読み込み。
// それ以外（ログイン・チーム管理・分析・JIRA設定）は初回バンドルから外し、
// 実際に開かれた時だけ読み込む
const LoginPage = lazy(() => import('./pages/LoginPage'));
const ForgotPasswordPage = lazy(() => import('./pages/ForgotPasswordPage'));
const ResetPasswordPage = lazy(() => import('./pages/ResetPasswordPage'));
const TeamsPage = lazy(() => import('./pages/TeamsPage'));
const TeamAnalyticsPage = lazy(() => import('./pages/TeamAnalyticsPage'));
const JiraSettingsPage = lazy(() => import('./pages/JiraSettingsPage'));
const JiraAnalyticsPage = lazy(() => import('./pages/JiraAnalyticsPage'));

// useLocationはRouter配下でしか使えないため、トラッキングは子コンポーネントで行う
const PageTracker: React.FC = () => {
  usePageTracking();
  return null;
};

function App() {
  // Render.com用の環境変数チェック
  const isRenderBuild = process.env.REACT_APP_RENDER_BUILD === 'true';
  const basename = isRenderBuild ? '/' : '/dev/planning_poker';

  return (
    <Router basename={basename}>
      <PageTracker />
      <div className="App">
        <Header />
        <main className="main-content">
          <Suspense fallback={<div className="route-loading" />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/room/:roomId" element={<Room />} />
              <Route path="/join/:roomId" element={<JoinRoom />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/teams" element={<TeamsPage />} />
              <Route path="/teams/:teamId" element={<TeamAnalyticsPage />} />
              <Route path="/jira-settings" element={<JiraSettingsPage />} />
              <Route path="/jira-analytics" element={<JiraAnalyticsPage />} />
            </Routes>
          </Suspense>
        </main>
      </div>
    </Router>
  );
}

export default App;
